<template>
  <section
    v-if="categories.length"
    data-qa="analyses_categories_section"
    class="analyses-categories-section d-flex flex-column ga-6"
  >
    <h2 class="text-h6 text--text mb-0">
      Категории анализов
    </h2>

    <CoreSwiper
      v-if="!isMobile"
      slides-per-view="auto"
      has-navigation
      :has-pagination="false"
      :space-between="16"
      class="analyses-categories-section__slider"
    >
      <template #slides="{ slideAttrs }">
        <div
          v-for="category in categoriesWithOther"
          :key="category.slug"
          v-bind="slideAttrs"
        >
          <AnalysesCategoryCard
            :name="category.name"
            :icon="category.icon"
            :href="category.href"
            @click="onOtherCategoryClick(category)"
          />
        </div>
      </template>
    </CoreSwiper>

    <CoreSwiper
      v-else
      :slides-per-view="1"
      :has-pagination="true"
      :space-between="16"
    >
      <template #slides="{ slideAttrs }">
        <div
          v-for="(page, pageIndex) in categoryPages"
          :key="pageIndex"
          v-bind="slideAttrs"
        >
          <div class="analyses-categories-section__grid ga-4">
            <AnalysesCategoryCard
              v-for="category in page"
              :key="category.slug"
              :name="category.name"
              :icon="category.icon"
              :href="category.href"
              @click="onOtherCategoryClick(category)"
            />
          </div>
        </div>
      </template>
    </CoreSwiper>

    <AnalysesOtherCategoriesDrawer v-model="isOtherDrawerOpen" />
  </section>
</template>

<script setup lang="ts">
import { computed, provide, ref } from 'vue'
import { chunk } from 'lodash'
import useContextStore from 'src/store/useContextStore'
import CoreSwiper from 'src/core/CoreSwiper/CoreSwiper.vue'
import AnalysesCategoryCard from 'src/components/pages/[town-translit]/diagnostika/analiz/components/AnalysesCategoryCard.vue'
import AnalysesOtherCategoriesDrawer
  from 'src/components/pages/[town-translit]/diagnostika/analiz/components/AnalysesOtherCategoriesDrawer.vue'
import type { AnalysisCategory } from 'src/components/pages/[town-translit]/diagnostika/analiz/components/types'

const OTHER_CATEGORY_SLUG = 'other'
const OTHER_CATEGORY_ICON = '/static/_v1/pd/pictures/analyzes/redesigned-category/prochee.png'

const props = defineProps<{
  categories: AnalysisCategory[]
}>()

const { context } = useContextStore()
const isMobile = computed(() => context.flavour === 'mobile')
const isOtherDrawerOpen = ref(false)

provide('isMobile', isMobile.value)

const categoriesWithOther = computed((): AnalysisCategory[] => [
  ...props.categories,
  {
    name: 'Прочее',
    slug: OTHER_CATEGORY_SLUG,
    icon: OTHER_CATEGORY_ICON,
    href: '',
  },
])

const categoryPages = computed(() => chunk(categoriesWithOther.value, 6))

const onOtherCategoryClick = (category: AnalysisCategory) => {
  if (category.slug === OTHER_CATEGORY_SLUG) {
    isOtherDrawerOpen.value = true
  }
}
</script>

<style lang="scss" scoped>
.analyses-categories-section {
  &__slider {
    :deep(.swiper-slide) {
      width: 146px;
    }

    :deep(.analyses-category-card) {
      width: 146px;
      min-height: 160px;
      height: 100%;
    }
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    width: 100%;

    :deep(.analyses-category-card) {
      width: 100%;
      min-width: 0;
      min-height: 148px;
    }
  }
}
</style>
